import {useCallback} from 'react';

import type {WidgetFragment} from 'nutshell-graphql-types';

import {useGetAccountChildLeads} from './graphql/hooks/use-get-account-child-leads';
import {getChildLeadsListLink} from './helpers';
import type {WidgetLeadStatus} from './leads-widget';
import {LeadsWidgetContent} from './leads-widget-content';

type Props = {
    accountId: string;
    widget: WidgetFragment;
};

export function ChildAccountLeadsWidget(props: Props) {
    const {leads, stats, isLoading, childAccountIds} = useGetAccountChildLeads(props.accountId);

    const getSeeAllLink = useCallback(
        (tab: WidgetLeadStatus) => getChildLeadsListLink(childAccountIds, tab),
        [childAccountIds]
    );

    return (
        <LeadsWidgetContent
            widget={props.widget}
            leads={leads}
            stats={stats}
            isLoading={isLoading}
            getSeeAllLink={getSeeAllLink}
        />
    );
}
